import {
  Typo3ButtonNew,
  Typo3SectionSpotSanityContentShop,
  Typo3SectionSpotSanityEventList
} from '@/types/typo3'
import { toDesignButton } from '..'

const toSectionCta = (
  section: Typo3SectionSpotSanityEventList | Typo3SectionSpotSanityContentShop
) => {
  const { type } = section

  if (type === 'spotsanity_eventlist') {
    return {
      section: section,
      title: section?.content?.items?.[0]?.title,
      titleLayout: section?.content?.titleLayout,
      text: section?.content?.items?.[0]?.summary,
      buttons: section.content.items?.map((btn) => toDesignButton(btn.button))
    }
  } else if (type === 'spotsanity_content_shop') {
    return {
      section: section,
      title: section?.content?.items?.[0]?.title,
      titleLayout: section?.content?.titleLayout,
      text: section?.content?.items?.[0]?.lead,
      buttons: section.content.items?.map((btn) =>
        toDesignButton(btn.button as Typo3ButtonNew)
      )
    }
  }
}

export default toSectionCta
